import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthFacade } from '@rx-applications/shared/auth/data-access';
import { RxAlertModule } from '@roomex/rx-components';
import { CommonModule } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-impersonate',
  templateUrl: './impersonate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RxAlertModule],
})
export class ImpersonateComponent {
  constructor(public authFacade: AuthFacade) {
    this.authFacade.impersonate();
  }
}
